"use client";

import React from "react";
import { Card, Typography } from "@material-tailwind/react";
import CountUp from "react-countup";
import Image from "next/image";

interface StatsCardProps {
  img: string;
  alt: string;
  count: string;
  title: string;
  client: string;
}

export default function StatsCard({ img, alt, count, title, client }: StatsCardProps) {
  const numeric = Number(count.replace(/,/g, ""));

  return (
    <Card {...({} as any)}  color="transparent" shadow={false} className="flex flex-col items-center text-center h-full">
      {/* Wrapper สำหรับ Next/Image */}
      <div className="relative w-40 h-40 flex justify-center items-center mb-1">
        <Image
          src={img}
          alt={alt} 
          width={417}
          height={407}
          loading="lazy"
          className="object-contain animate-pulse-slow"
        />
      </div>

      <Typography  {...({} as any)}  variant="h1" className="mb-2 mt-2 text-5xl text-[#2998E2]">
        <CountUp
          start={0}
          end={numeric}
          duration={1.5}
          separator="," 
          decimals={count.includes(".") ? 2 : 0}
          enableScrollSpy
          scrollSpyOnce={false}
          redraw
        >
          {({ countUpRef }) => <span ref={countUpRef} />}
        </CountUp>
      </Typography>

      <Typography  {...({} as any)}  as="p" variant="paragraph" color="blue-gray" className="font-semibold whitespace-pre-line tracking-wide">
        {title}
      </Typography>

      <Typography  {...({} as any)}  as="p" variant="paragraph" className="font-semibold tracking-wide text-[#2998E2]">
        {client}
      </Typography>
    </Card>
  );
}
